import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, makeStyles, Typography } from "@material-ui/core"
import React from "react"
import { X } from "react-feather"
import { LIGHT_GRAY_COLOR, PRIMARY_COLOR, SECONDARY_COLOR } from "../../theme"
import Botao from "./Botao"

const Modal = (props) => {
	const classes = useStyles(props)
	const {
		desabilitarCliqueForaModal,
		desativarTeclaEsc,
		botaoSecundario,
		botaoPrincipal,
		fecharModal,
		modalAberto,
		iconeFechar,
		iconeTitulo,
		className,
		preTitulo,
		tipoErro,
		maxWidth,
		titulo
	} = props

	const existemDoisBotoes = Boolean(botaoPrincipal && botaoSecundario)
	const tamanhoBotoes = existemDoisBotoes ? 6 : 12

	return (
		<Dialog
			open={modalAberto}
			onClose={fecharModal}
			scroll="body"
			maxWidth={maxWidth}
			fullWidth
			className={`${classes.modal} ${className}`}
			classes={{
				paper: `${classes.modalPapel} ${tipoErro && classes.bordaModalErro} `,
			}}
			disableBackdropClick={desabilitarCliqueForaModal}
			disableEscapeKeyDown={desativarTeclaEsc}
		>
			{iconeFechar && (
				<X color={LIGHT_GRAY_COLOR} className={`pointer ${classes.iconeFechar}`} onClick={fecharModal} />
			)}

			{preTitulo && <Box className={`${classes.containerPreTitulo} pt-8`}>{preTitulo}</Box>}

			{titulo && (
				<DialogTitle disableTypography onClose={fecharModal} className={`${classes.containerTitulo} pt-8`}>
					{iconeTitulo && <Box className="pb-4">{iconeTitulo}</Box>}
					<Typography className={`${tipoErro ? classes.tituloErro : classes.titulo}`} align="center" variant="h4">
						{titulo}
					</Typography>
				</DialogTitle>
			)}
			<DialogContent className={classes.paddingModal}>{props.children}</DialogContent>
			{(botaoSecundario || botaoPrincipal) && (
				<DialogActions className="p-8 pt-0">
					<Grid container spacing={3}>
						{botaoSecundario && (
							<Grid item align={existemDoisBotoes ? "left" : "center"} xs={tamanhoBotoes}>
								<Botao
									titulo={botaoSecundario.texto}
									atalho={botaoSecundario.atalho}
									onClick={botaoSecundario.acao}
									href={botaoSecundario.href}
									target={botaoSecundario.abrirNovaAba ? "_blank" : "_self"}
									type="secondary"
									className={classes.botao}
									uppercase={false}
									disabled={botaoSecundario.desabilitado}
									carregando={botaoSecundario.carregando}
								/>
							</Grid>
						)}
						{botaoPrincipal && (
							<Grid item align={existemDoisBotoes ? "right" : "center"} xs={tamanhoBotoes}>
								<Botao
									titulo={botaoPrincipal.texto}
									atalho={botaoPrincipal.atalho}
									onClick={botaoPrincipal.acao}
									href={botaoPrincipal.href}
									target={botaoPrincipal.abrirNovaAba ? "_blank" : "_self"}
									className={botaoPrincipal.className || classes.botao}
									type="primary"
									uppercase={false}
									disabled={botaoPrincipal.desabilitado}
									carregando={botaoPrincipal.carregando}
								/>
							</Grid>
						)}
					</Grid>
				</DialogActions>
			)}
		</Dialog>
	)
}

const useStyles = makeStyles({
	botao: {
		width: "100%",
		height: "56px",
	},
	modal: {
		overflow: "hidden",
		width: "100%",
		maxHeight: "100%",
		"& .Mui-focused fieldset": {
			borderColor: "#BF43AB !important",
		},
	},

	bordaModalErro: {
		border: `2px solid ${SECONDARY_COLOR}`,
	},
	containerPreTitulo: {
		textAlign: "center",
	},
	titulo: {
		color: PRIMARY_COLOR,
	},
	tituloErro: {
		color: SECONDARY_COLOR,
	},
	iconeFechar: {
		position: "absolute",
		right: 0,
		margin: '36px 36px 0 0'
	},
	containerTitulo: {
		textAlign: "center",
		padding: "16px 70px 6px",
	},
	paddingModal:{
		padding: '36px'	
	}
})

export default Modal
